import appConfig from "../../../appconfig";
import { FirebaseAnalytics } from "@capacitor-community/firebase-analytics";
import {extractShopContext} from "../../../libraries/globalTemplateSpecific/bm100/utils";
import {store} from "../../../store";
import {flatten} from "lodash";
import {getDeliveryMethodByNumberValue} from "../../../domains2/libraries/DeliveryMethods";

const tenantConfig = appConfig.tenantConfig;

const getEventName = (eventName) => {
	return eventName.includes(" ") ? eventName.split(" ").join("_") : eventName;
};

const getPrice = function (item) {
	if(item.productPrice) {
		return item.productPrice.discountPrice ? item.productPrice.discountPrice : item.productPrice.basePrice;
	}
	return item.product.price;
};

export const calculateCategoryTotal = function (items) {
	return flatten(items).reduce((acc, curr) => {
		// there are some specific cases for kiosk where non-product items are pushed into category
		// these don't have productPrice and we can use this as a check for the aggregation
		return curr.productPrice ? acc + (curr.productPrice.discountPrice || curr.productPrice.basePrice) : acc + 0;}, 0);
};
export const pushGTMeCommerceData = async function({eventName, products, category, value, currency, order}) {
	if(products.filter(Boolean).length < 1) return;
	const {shouldPushWeather, weatherData} = extractShopContext();
	appConfig.googleTagManagerDataLayer.push({ecommerce: null});

	const shopName = store.getters.globalSelectedShop && store.getters.globalSelectedShop.shopNameAlias;
	const deliveryMethod = Number.isInteger(store.getters.tenantSpecificData.deliveryChoice)
		? getDeliveryMethodByNumberValue(store.getters.tenantSpecificData.deliveryChoice)
		: undefined;

	function getItemCategory(item, category) {
		if(item.category) {
			return item.category;
		}
		return category ? category.name : "Unclassified";
	}
	function getProductQuantity(item) {
		if(item.quantity) {
			return item.quantity;
		}
		if(item.product && item.product.quantity) {
			return item.product.quantity;
		}
		return 1;
	}
	try {
		let coupon;
		const dataLayerObject = {
			event: eventName,
			selected_restaurant: shopName,
			chosen_delivery_method: deliveryMethod,
			temperature: shouldPushWeather	? weatherData && weatherData.temperature : undefined,
			rain: shouldPushWeather	? weatherData && weatherData.rain : undefined,
			ecommerce: {
				transaction_id: order ? order.orderNumber : undefined,
				affiliation: "Online Store",
				currency: currency ? currency : tenantConfig.currency,
				tax: order ? +(value * 0.2).toFixed(2) : undefined,
				value: +(value).toFixed(2),
				items: flatten(products).map((item) => {
					if(item.product) {
						const productData = {
							item_id: item.product.id,
							item_name: item.product.name,
							currency: currency ? currency : tenantConfig.currency,
							// if we cannot provide category, Unclassified is sent
							item_category: getItemCategory(item, category),
							item_category2: item.product.item_category2,
							price: getPrice(item),
							quantity: getProductQuantity(item),
							discount: item.product.discount ? item.product.discount.discountValue : 0
						};
						if(item.product.discount) {
							coupon = item.product.discount.discountType;
							return {
								...productData,
								coupon: item.product.discount.discountType
							};
						}
						return productData;
					}
				}).filter(Boolean),
				coupon
			}
		};
		if (appConfig.mobile.isMobileApp()) {
			await FirebaseAnalytics.logEvent({
				name: getEventName(eventName),
				params: {
					...dataLayerObject.ecommerce
				}
			});
		}

		appConfig.googleTagManagerDataLayer.push(dataLayerObject);
	} catch (e) {
		// even if pushing to dataLayer fails, we want to continue execution
	}
};